import { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import Title from 'antd/lib/typography/Title';
import astranaLogoPlum from 'assets/images/Astrana_Logo_Plum.svg';
import { ORGANIZATION_NAME } from "utils/objects";

const MemoReminderModal = () => {

  useEffect(() => {
    setShowAPCMusculoskeletal(localStorage.getItem('musculoskeletalAPCPopup') !== 'seen' && sessionStorage.getItem('ipa')! === 'APC');
    setShowAHCMusculoskeletal(localStorage.getItem('musculoskeletalAHCPopup') !== 'seen' && sessionStorage.getItem('ipa')! === 'AHC');
    setShowAPCLungNodule(localStorage.getItem('lungNoduleAPCPopup') !== 'seen' && sessionStorage.getItem('ipa')! === 'APC');
    setShowAHCLungNodule(localStorage.getItem('lungNoduleAHCPopup') !== 'seen' && sessionStorage.getItem('ipa')! === 'AHC');
  }, []);

  const [showAPCMusculoskeletal, setShowAPCMusculoskeletal] = useState(false);
  const [showAHCMusculoskeletal, setShowAHCMusculoskeletal] = useState(false);
  const [showAPCLungNodulePopup, setShowAPCLungNodule] = useState(false);
  const [showAHCLungNodulePopup, setShowAHCLungNodule] = useState(false);

  const hideAPCLungNodule = () => {
    localStorage.setItem('lungNoduleAPCPopup', sessionStorage.getItem('ipa')! === 'APC' ? 'seen' : '');
    setShowAPCLungNodule(false);
  }

  const hideAHCLungNodule = () => {
    localStorage.setItem('lungNoduleAHCPopup', sessionStorage.getItem('ipa')! === 'AHC' ? 'seen' : '');
    setShowAHCLungNodule(false);
  }

  const hideAPCMusculoskeletal = () => {
    localStorage.setItem('musculoskeletalAPCPopup', sessionStorage.getItem('ipa')! === 'APC' ? 'seen' : '');
    setShowAPCMusculoskeletal(false);
  }

  const hideAHCMusculoskeletal = () => {
    localStorage.setItem('musculoskeletalAHCPopup', sessionStorage.getItem('ipa')! === 'AHC' ? 'seen' : '');
    setShowAHCMusculoskeletal(false);
  }

  return (
    <>
      <Modal
        closable={false}
        className="musculoskeletal-popup"
        width={'1200px'}
        visible={showAPCMusculoskeletal}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => hideAPCMusculoskeletal()}
          >
            Close
          </Button>
        ]}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
            position: "relative", // Add position relative to the container
          }}
        >
          <img
            src={astranaLogoPlum}
            width={"250px"}
            style={{ position: "absolute", top: 0 }} // Position the image at the top
          />
          <Title level={2} style={{ marginTop: "40px" }}>Musculoskeletal and Pain Clinic – REMINDER</Title>
        </div>

        <p style={{ fontSize: "14px" }}>
        Dear Providers,
        <br/><br/>
          Based on survey data, our Members have a significant number of inappropriate evaluations and
          treatment of their back pain. <br/><br/>
          There is an algorithm to evaluate chronic/acute back pain. Based on expert findings surgical
          intervention in treatment of these Members is a last resort. Therefore, Allied Pacific IPA has
          created a Musculoskeletal Clinic to prioritize back pain with immediate access and evaluation to
          quickly identify the pain reasons and location and start treatment should be the correct approach. <br/><br/>
          Physical therapy and medical treatment with multiple modalities to treat the affected areas and
          to proceed to the appropriate radiological studies before referral to the most appropriate surgical
          evaluation: Neurosurgery or Orthopedic surgery in this stepwise fashion. The patient gets the
          expert treatment, immediate access, proper selection of surgery without delay, reduction of
          inappropriate surgery and complications therefore improving quality of care. <br/><br/>
          If you have any questions please contact Provider Relations Department at 626-943-6100. <br/><br/>
          Best regards, <br/><br/>
        </p>
        <p>
          Albert Young, MD, MPH <br/>
          Chief Administrative Officer <br/>
          {ORGANIZATION_NAME}
        </p>
      </Modal>

      <Modal
        closable={false}
        className="musculoskeletal-popup"
        width={'1200px'}
        visible={showAHCMusculoskeletal}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => hideAHCMusculoskeletal()}
          >
            Close
          </Button>
        ]}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
            position: "relative", // Add position relative to the container
          }}
        >
          <img
            src={astranaLogoPlum}
            width={"250px"}
            style={{ position: "absolute", top: 0 }} // Position the image at the top
          />
          <Title level={2} style={{ marginTop: "40px" }}>Musculoskeletal and Pain Clinic – REMINDER</Title>
        </div>

        <p style={{ fontSize: "14px" }}>
        Dear Providers,
        <br/><br/>
          Based on survey data, our Members have a significant number of inappropriate evaluations and
          treatment of their back pain. <br/><br/>
          There is an algorithm to evaluate chronic/acute back pain. Based on expert findings surgical
          intervention in treatment of these Members is a last resort. Therefore, Allied Pacific IPA has
          created a Musculoskeletal Clinic to prioritize back pain with immediate access and evaluation to
          quickly identify the pain reasons and location and start treatment should be the correct approach. <br/><br/>
          Physical therapy and medical treatment with multiple modalities to treat the affected areas and
          to proceed to the appropriate radiological studies before referral to the most appropriate surgical
          evaluation: Neurosurgery or Orthopedic surgery in this stepwise fashion. The patient gets the
          expert treatment, immediate access, proper selection of surgery without delay, reduction of
          inappropriate surgery and complications therefore improving quality of care. <br/><br/>
          If you have any questions please contact Provider Relations Department at 626-943-6100. <br/><br/>
          Best regards, <br/><br/>
        </p>
        <p>
          Albert Young, MD, MPH <br/>
          Chief Administrative Officer <br/>
          {ORGANIZATION_NAME}
        </p>
      </Modal>

      <Modal
        closable={false}
        className="lung-nodule-popup"
        width={'1200px'}
        visible={showAPCLungNodulePopup}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => hideAPCLungNodule()}
          >
            Close
          </Button>
        ]}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
            position: "relative", // Add position relative to the container
          }}
        >
          <img
            src={astranaLogoPlum}
            width={"250px"}
            style={{ position: "absolute", top: 0 }} // Position the image at the top
          />
          <Title level={2} style={{ marginTop: "40px" }}>Lung Nodule and Chest Clinic – REMINDER</Title>
        </div>

        <p style={{ fontSize: "14px" }}>
        Dear Providers,
        <br/><br/>
          Allied Pacific IPA would like provide the best quality healthcare to its Members and to their Providers. <br/><br/>
          It is the access to care and expedited care without delay to the proper Specialists that is most important. <br/><br/>
          Starting from March 1, 2023, all chest nodule and mediastinal mass referrals from Primary Care
          Providers should refer to: <br/><br/>
        </p>
        <p style={{ "textAlign": "center" }}>
          Dr. Jairo Espinosa <br/>
          Cardiothoracic Surgeon <br/>
          Office: (626) 308-3800
        </p>
        <br />
        <p>
          Therefore, the access will be immediate and service will be without delay. A list of qualifying ICD-10
          codes will be directed at the Provider Portal level also (Attached). <br/><br/>
          The Chest Nodule Clinic is ready to serve the needs of thoracic surgery. We appreciate your attention
          and cooperation to make is a quality experience for Allied Pacific Members. <br/><br/>
          If you have any questions please contact Provider Relations Department at 626-943-6100. <br/><br/>
          Best regards, <br/><br/>
        </p>
        <p>
          Albert Young, MD, MPH <br/>
          Chief Administrative Officer <br/>
          {ORGANIZATION_NAME}
        </p>
        <br />
          <p style={{ "textAlign": "center"}}><b>Lung Nodule and Chest Clinic ICD-10 Codes</b></p>
        <br/>
        <div>
          <ul>
            <li>Pulmonary Nodule: R98.4, R91.4, R91.1, R91.8, R91.9</li>
            <li>Mediastinal Mass: D38.3, C38.0, C38.1, C38.2, C38.3, C38.6, C38.9, J98.5</li>
            <li>R91.8: Lung Mass</li>
            <li>D13: Benign neoplasm of digestive system</li>
            <li>K44: Diaphragmatic hernia</li>
            <li>K22.0: Achalasia of cardia</li>
            <li>K22.5: Diverticulum of esophagus</li>
            <li>J91.8: Pleural effusion</li>
            <li>J94.0: Chylous effusion</li>
            <li>J94.2: Hemothorax</li>
            <li>J94.8: Other pleural conditions</li>
            <li>J85: Abscess of lung and mediastinum</li>
            <li>J86: Pyothorax</li>
          </ul>
        </div>
      </Modal>

      <Modal
        closable={false}
        className="lung-nodule-popup"
        width={'1200px'}
        visible={showAHCLungNodulePopup}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => hideAHCLungNodule()}
          >
            Close
          </Button>
        ]}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
            position: "relative", // Add position relative to the container
          }}
        >
          <img
            src={astranaLogoPlum}
            width={"250px"}
            style={{ position: "absolute", top: 0 }} // Position the image at the top
          />
          <Title level={2} style={{ marginTop: "40px" }}>Lung Nodule and Chest Clinic – REMINDER</Title>
        </div>

        <p style={{ fontSize: "14px" }}>
        Dear Providers,
        <br/><br/>
          Accountable HealthCare would like provide the best quality healthcare to its Members and to their Providers. <br/><br/>
          It is the access to care and expedited care without delay to the proper Specialists that is most important. <br/><br/>
          Starting from March 1, 2023, all chest nodule and mediastinal mass referrals from Primary Care
          Providers should refer to: <br/><br/>
        </p>
        <p style={{ "textAlign": "center" }}>
          Dr. Jairo Espinosa <br/>
          Cardiothoracic Surgeon <br/>
          Office: (626) 308-3800
        </p>
        <br />
        <p>
          Therefore, the access will be immediate and service will be without delay. A list of qualifying ICD-10
          codes will be directed at the Provider Portal level also (Attached). <br/><br/>
          The Chest Nodule Clinic is ready to serve the needs of thoracic surgery. We appreciate your attention
          and cooperation to make is a quality experience for Allied Pacific Members. <br/><br/>
          If you have any questions please contact Provider Relations Department at 626-943-6100. <br/><br/>
          Best regards, <br/><br/>
        </p>
        <p>
          Albert Young, MD, MPH <br/>
          Chief Administrative Officer <br/>
          {ORGANIZATION_NAME}
        </p>
        <br />
          <p style={{ "textAlign": "center"}}><b>Lung Nodule and Chest Clinic ICD-10 Codes</b></p>
        <br/>
        <div>
          <ul>
            <li>Pulmonary Nodule: R98.4, R91.4, R91.1, R91.8, R91.9</li>
            <li>Mediastinal Mass: D38.3, C38.0, C38.1, C38.2, C38.3, C38.6, C38.9, J98.5</li>
            <li>R91.8: Lung Mass</li>
            <li>D13: Benign neoplasm of digestive system</li>
            <li>K44: Diaphragmatic hernia</li>
            <li>K22.0: Achalasia of cardia</li>
            <li>K22.5: Diverticulum of esophagus</li>
            <li>J91.8: Pleural effusion</li>
            <li>J94.0: Chylous effusion</li>
            <li>J94.2: Hemothorax</li>
            <li>J94.8: Other pleural conditions</li>
            <li>J85: Abscess of lung and mediastinum</li>
            <li>J86: Pyothorax</li>
          </ul>
        </div>
      </Modal>
    </>
  )
}

export default MemoReminderModal;